var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.083 17.225h.954l6.03 6.041-1.8 1.8-6.042-6.029v-.954l-.327-.339a7.82 7.82 0 0 1-5.11 1.897 7.854 7.854 0 1 1 0-15.708 7.854 7.854 0 0 1 7.853 7.854 7.82 7.82 0 0 1-1.897 5.111l.339.327zM6.35 11.787a5.43 5.43 0 0 0 5.437 5.438 5.43 5.43 0 0 0 5.438-5.438 5.43 5.43 0 0 0-5.438-5.437 5.43 5.43 0 0 0-5.437 5.437z"
  })));
};
export default SvgSearch;